// extracted by mini-css-extract-plugin
export default {"congrats":"newBadgeCongratulation_congrats__LroJ1","close":"newBadgeCongratulation_close__Q+8Uo","container":"newBadgeCongratulation_container__wxHDD"};